import { render, staticRenderFns } from "./CarouselPortfolio.vue?vue&type=template&id=0c889c88&scoped=true&"
import script from "./CarouselPortfolio.vue?vue&type=script&lang=js&"
export * from "./CarouselPortfolio.vue?vue&type=script&lang=js&"
import style0 from "./CarouselPortfolio.vue?vue&type=style&index=0&id=0c889c88&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c889c88",
  null
  
)

export default component.exports